export default {
    namespaced: true,

    state: {
        isLoggedIn: false,

        user: {
            id: null,
            username: null
        },
    },

    getters: {},

    mutations: {
        updateUser(state, user) {
            state.user = user;
        },

        setLoggedIn(state, flag) {
            state.isLoggedIn = flag;
        },
    },

    actions: {
        // Actions：处理异步操作，可以调用 mutations。
    },
};
